<template>
  <div class="stripe stripe--pay-button" v-if="canMakePayment">
    <div ref="element" class="pay-button"></div>
  </div>
</template>
<script>
export default {
  props: {
    stripeKey: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {
          style: {
            paymentRequestButton: {
              height: '48px',
            },
          },
        };
      },
    },
  },
  data() {
    // eslint-disable-next-line
    const stripe = Stripe(this.stripeKey);
    return {
      elements: stripe.elements(),
      paymentRequest: stripe.paymentRequest(this.$store.getters.paymentRequest),
      paymentRequestButton: null,
      canMakePayment: this.$store.state.supportsPayButton,
      isOpen: false,
    };
  },
  computed: {
    paymentRequestData() {
      return this.$store.getters.paymentRequest;
    },
  },
  mounted() {
    this.paymentRequest.canMakePayment().then((result) => {
      this.canMakePayment = result !== null;
      if (!this.canMakePayment) {
        return;
      }
      this.paymentRequestButton = this.elements.create('paymentRequestButton', { paymentRequest: this.paymentRequest, ...this.options });
      this.paymentRequestButton.mount(this.$refs.element);
      this.paymentRequestButton.on('click', () => {
        this.isOpen = true;
      });
    });
    this.paymentRequest.on('cancel', () => {
      this.isOpen = false;
    });

    this.paymentRequest.on('token', (event) => {
      // console.log(event);
      this.$emit('token', event);
    });
    this.paymentRequest.on('shippingoptionchange', (event) => {
      this.$store.dispatch('updateRegistration', {
        fullfillCard: event.shippingOption.id === 'fullfill_card',
      });
      const { total, displayItems, shippingOptions } = this.$store.getters.paymentRequest;
      console.log(event);
      event.updateWith({
        status: 'success',
        total,
        displayItems,
        shippingOptions,
      });
    });
  },
  watch: {
    paymentRequestData() {
      if (!this.isOpen) {
        this.paymentRequest.update(this.paymentRequestData);
      }
    },
  },
};
</script>
